import React from "react";

/**
 * Unified Loading Spinner component.
 *
 * Replaces all one-off CSS spinners and FontAwesome spin icons
 * used for section/page loading states.
 *
 * Sizes:
 *  - "sm"  : 20px — inline indicators (table cells, small sections)
 *  - "md"  : 32px — dashboard cards, compact sections
 *  - "lg"  : 48px — full page / section loading (default)
 *
 * @param {string}  message   – Loading text shown below the spinner.
 * @param {string}  size      – "sm" | "md" | "lg"
 * @param {string}  className – Escape-hatch for extra wrapper styling.
 */
const LoadingSpinner = ({ message, size = "lg", className = "" }) => {
  const wrapperClasses = ["loading-spinner-wrapper", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClasses}>
      <div className={`unified-spinner unified-spinner-${size}`}></div>
      {message && <span className="loading-spinner-message">{message}</span>}
    </div>
  );
};

export default LoadingSpinner;
